export function LoadingScreen({
  message = "Loading…"
}: {
  message?: string;
}) {
  return (
    <main className="loading-screen">
      <div className="spinner" />
      <strong>{message}</strong>
    </main>
  );
}
